import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { inject } from "../../../lib/itn-ui-kit/services/service-container";

const Template = () => {
  const landingService = inject("landing-service");
  const navigate = useNavigate();

  useEffect(() => {
    const accessibleRoutes = landingService.PriorityAccessibleRoute;
    navigate(accessibleRoutes);
  }, []);

  return null;
};

export default Template;
